import { render } from "./ParralaxImg.vue?vue&type=template&id=a7f84cb4&scoped=true"
import script from "./ParralaxImg.vue?vue&type=script&lang=js"
export * from "./ParralaxImg.vue?vue&type=script&lang=js"

import "./ParralaxImg.vue?vue&type=style&index=0&id=a7f84cb4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a7f84cb4"

export default script